export default __webpack_public_path__ + "static/media/record.e5c0caf2.svg";